<template>

  <span class="copy-button">
    <span class="msg">{{ text }}
  </span>
      <b-button @click="copyData()"><font-awesome-icon icon="copy" class="text-primary" /></b-button>
  </span>
    
</template>

<script>
export default {
  name: "copyButton",
  components: {},
  computed: {},
  props: {
    copyText: String
  },
  data() {
    return {
      itemToCopy: "",
      text: "Copy?"
    };
  },
  created() {},
  methods: {
    copyData() {
      if (
        typeof this.copyText !== "undefined" &&
        typeof this.copyText === "string"
      ) {
        this.itemToCopy = this.copyText;
        this.text = "Copied!";
      }
      // Create new element
      var el = document.createElement("textarea");
      // Set value (string to be copied)
      el.value = this.itemToCopy;
      // Set non-editable to avoid focus and move outside of view
      el.setAttribute("readonly", "");
      el.style = { position: "absolute", left: "-9999px" };
      document.body.appendChild(el);
      // Select text inside element
      el.select();
      // Copy text to clipboard
      document.execCommand("copy");
      // Remove temporary element
      document.body.removeChild(el);
      setTimeout(() => {
        this.text = "Copy?";
      }, 1000);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.copy-button {
  cursor: pointer;
  .msg {
    background-color: #a5a5a5;
    position: absolute;
    width: 45px;
    text-align: center;
    color: #ffffff;
    font-size: 9px;
    -webkit-border-radius: 50px;
    border-radius: 50px;
    opacity: 0;
    margin: -7px 0 0 -11px;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
    z-index: 0;
  }
  &:hover {
    .msg {
      display: inherit;
      margin: -10px 0 0 -11px;
      opacity: 1;
    }
  }
  button {
    background-color: transparent;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 3px;
    position: relative;
    margin-top: -6px;
  }
}
</style>
